import { Table } from '@digital/ui';
import React, { useState, useMemo, useEffect } from 'react';
import { Switch, Icon, Collapse } from 'antd';
import { Colunas, getAllPerfilComModuloByPerfilId, PutModuloPerfil, putUpdateModuloPerfil } from '@app/api/PerfilAcesso';
import { boolean } from 'yup';


interface TabelaPermissaoPerfilProps {
    nomesColunas: Colunas[],
    perfilId: string
}

const TabelaPermissaoPerfil = (props: TabelaPermissaoPerfilProps) => {

    const { nomesColunas, perfilId } = props;
    const [dataResult, setDataResult] = useState();

    useEffect(() => {
        getAllPermissaoAndModulo();
    }, [perfilId]);

    const getAllPermissaoAndModulo = () => {
        setDataResult([]);
        getAllPerfilComModuloByPerfilId(perfilId).then((data) => {
            if (data) {
                setDataResult(data.dataTable);
            }

        });
    }

    const updateModuloPerfil = (moduloId: string, tipoModuloId: string, perfilId: string, checked: boolean) => {
        putUpdateModuloPerfil({ moduloId: moduloId, perfilId: perfilId, tipoModuloId: tipoModuloId, checked: checked } as PutModuloPerfil);
    }


    const collunas = () => {

        const collunasResult = [];

        collunasResult.push(
            {
                title: 'N',
                dataIndex: 'index',
            },
            {
                title: 'Modulo',
                dataIndex: 'modulo',
            },
        );

        if (nomesColunas && nomesColunas.length > 0) {
            nomesColunas.map((coluna) => {
                collunasResult.push(
                    {
                        title: `${coluna.title}`,
                        dataIndex: `${coluna.dataIndex}`,
                        render: (index, record) => {
                            return <>
                                <Switch
                                    defaultChecked={tratarValorSwitc(record[`${coluna.dataIndex}`])}
                                    id={`${coluna.dataIndex}`}
                                    onChange={(checked: boolean, event: Event) => {
                                        updateModuloPerfil(record.moduloId, coluna.dataIndex, perfilId, checked);
                                    }}
                                />
                            </>
                        }
                    }
                )
            });
        }

        return collunasResult;
    }

    const tratarValorSwitc = (valor: string): boolean => {
        if (valor === 'true' || valor === 'True' || valor === 'TRUE') {
            return true;
        }
        return false;
    }

    return (
        <>
            <Table
                dataSource={dataResult}
                columns={collunas()}
                pagination={false}
            />
        </>
    )

}

export default TabelaPermissaoPerfil;